import { IFileMetaData } from '@publishing-engine/domain/models';
import dateFormat from 'dateformat';
export const getUpdatedOn = (
  log: IFileMetaData | null,
  uploadedBy?: string,
  date?: string,
  roleName?: string
) => {
  const formattedDate = dateFormat(log?.date ? log?.date : date, 'mmm d, yyyy');

  return log?.uploadedBy
    ? `${formattedDate} by ${log?.uploadedBy} (${log?.roleName})`
    : `${formattedDate} by ${uploadedBy} (${roleName})`;
};
